import { render } from "./BaseCardUser.vue?vue&type=template&id=ff09d22c&scoped=true"
import script from "./BaseCardUser.vue?vue&type=script&lang=js"
export * from "./BaseCardUser.vue?vue&type=script&lang=js"

import "./BaseCardUser.vue?vue&type=style&index=0&id=ff09d22c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ff09d22c"

export default script